'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Content;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _buttonContent = require('./buttonContent');

var _buttonContent2 = _interopRequireDefault(_buttonContent);

var _Spinner = require('../Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var variantMap = {
  base: 'base',
  neutral: 'base',
  brand: 'inverse',
  destructive: 'inverse',
  success: 'inverse',
  inverse: 'inverse',
  'outline-brand': 'brand',
  'border-inverse': 'inverse'
};

function Content(_ref) {
  var label = _ref.label,
      children = _ref.children,
      variant = _ref.variant,
      isLoading = _ref.isLoading;

  if (isLoading) {
    return _react2.default.createElement('span', {
      className: 'rainbow-button_content--hidden'
    }, _react2.default.createElement(_buttonContent2.default, {
      label: label
    }, children), _react2.default.createElement(_Spinner2.default, {
      className: 'rainbow-button_spinner--visible',
      isVisible: isLoading,
      variant: variantMap[variant],
      size: 'small'
    }));
  }

  return _react2.default.createElement(_buttonContent2.default, {
    label: label
  }, children);
}

Content.propTypes = {
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.object]),
  variant: _propTypes2.default.oneOf(['base', 'neutral', 'brand', 'outline-brand', 'destructive', 'success', 'inverse', 'border-inverse']),
  isLoading: _propTypes2.default.bool
};
Content.defaultProps = {
  label: undefined,
  children: null,
  variant: 'neutral',
  isLoading: false
};